package ai.jessie.shared.work

import kotlinx.serialization.Serializable

@Serializable
data class SaveWorkRequest(
    val workDate: String,
    val durationMinutes: Int,
    val memberId: String,
    val projectId: String,
    val positionId: String,
    val description: String? = null,
    val expectedRevision: Long? = null,
)

// UC-008 B1: unavailable integration must not be presented as unlinked/unprotected work.
// UC-013: the server reports authoritative billing; UNAVAILABLE is retained for older clients.
@Serializable
enum class WorkInvoiceStatus {
    UNAVAILABLE,
    UNBILLED,
    DRAFT,
    ISSUED,
}

@Serializable
data class WorkResponse(
    val id: String,
    val workDate: String,
    val durationMinutes: Int,
    val memberId: String,
    val projectId: String,
    val positionId: String,
    val description: String?,
    val revision: Long,
    val createdAt: String,
    val updatedAt: String,
    val invoiceStatus: WorkInvoiceStatus,
)

@Serializable data class WorkMemberOption(val id: String, val name: String?)

@Serializable data class WorkPositionOption(val id: String, val name: String)

@Serializable
data class WorkProjectOption(
    val id: String,
    val name: String,
    val positions: List<WorkPositionOption>,
)

@Serializable
data class WorkSelectionsResponse(
    val currentDate: String,
    val members: List<WorkMemberOption>,
    val projects: List<WorkProjectOption>,
)

@Serializable data class WorkFieldProblem(val field: String, val reason: String)

@Serializable
data class WorkProblemResponse(
    val code: String,
    val problems: List<WorkFieldProblem> = emptyList(),
    val current: WorkResponse? = null,
)
